import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { SharedComponentsModule } from "../shared/shared-components/shared.components.module";
import { LanguageSelectionComponent } from "./language-selection.component";

@NgModule({
  declarations: [
    LanguageSelectionComponent,
  ],
  imports: [
    CommonModule,
    SharedComponentsModule,
    TranslateModule,
  ],
  exports: [
    LanguageSelectionComponent,
  ]
})
export class LanguageSelectionModule { }
